// ============================================
// Frontend Logger (structured logging for browser)
// ============================================
class FrontendLogger {
    isDev;
    appName = "landing-platform-frontend";
    constructor() {
        this.isDev = import.meta.env.DEV;
    }
    format(level, message, context) {
        return {
            timestamp: new Date().toISOString(),
            level,
            message,
            app: this.appName,
            url: window.location.href,
            ...context,
        };
    }
    debug(message, context) {
        if (this.isDev) {
            console.debug(`[DEBUG] ${message}`, this.format("debug", message, context));
        }
    }
    info(message, context) {
        console.info(`[INFO] ${message}`, this.format("info", message, context));
    }
    warn(message, context) {
        console.warn(`[WARN] ${message}`, this.format("warn", message, context));
    }
    error(message, context) {
        console.error(`[ERROR] ${message}`, this.format("error", message, context));
        // In production, send to monitoring service
        if (!this.isDev) {
            this.sendToMonitoring(message, context);
        }
    }
    async sendToMonitoring(_message, _context) {
        try {
            // Placeholder for monitoring integration (Sentry, LogRocket, etc.)
            // await fetch("/api/v1/analytics/error", {
            //   method: "POST",
            //   headers: { "Content-Type": "application/json" },
            //   body: JSON.stringify({ message, context }),
            // });
        }
        catch {
            // Silently fail - logging should never break the app
        }
    }
}
let _logger = null;
export function getLogger() {
    if (!_logger) {
        _logger = new FrontendLogger();
    }
    return _logger;
}
